import React, {useMemo, useState} from 'react'
import {useQuery} from 'react-query'
import {getAll} from '../../../services/common_requests'
import {useQueryResponse, ResponseData} from '../../user-management/users-list/core/QueryResponseProvider'
import {useQueryRequest} from '../../user-management/users-list/core/QueryRequestProvider'
import {buildUserApiQuery} from '../../user-management/users-list/core/userListQuery'
import {KTCard} from '../../../../_dashboard/helpers'
import {ClientsTable} from './ClientsTable'
import {ClientsListHeader} from './ClientsListHeader'
import {UserDetailsModal} from '../../user-management/users-list/user-details-modal/UserDetailsModal'
import {UserFormModal} from '../../user-management/users-list/user-form-modal/UserFormModal'
import {useListView} from '../../user-management/users-list/core/ListViewProvider'

const ClientsList: React.FC = () => {
  const {itemIdForUpdate, viewUserId} = useListView()
  const {updateState} = useQueryResponse()
  const {state: queryState} = useQueryRequest()
  const [filters, setFilters] = useState({
    page: 0,
    size: 10,
    status: '' as string,
    role: '',
  })

  const queryParams = useMemo(
    () =>
      buildUserApiQuery(queryState, {
        page: filters.page,
        size: filters.size,
        listScope: 'clients',
        ...(queryState.search ? {searchUser: queryState.search} : {}),
        ...(filters.status ? {status: filters.status} : {}),
      }),
    [filters.page, filters.size, filters.status, queryState],
  )

  useQuery<ResponseData>(
    ['clients', queryParams],
    () => getAll(queryParams, '/users'),
    {
      enabled: true,
      onSuccess: (data) => {
        updateState(data)
      },
    },
  )

  return (
    <>
      <KTCard>
        <ClientsListHeader filters={filters} setFilters={setFilters} />
        <ClientsTable setFilters={setFilters} />
      </KTCard>
      {viewUserId && <UserDetailsModal />}
      {itemIdForUpdate && <UserFormModal />}
    </>
  )
}

export {ClientsList}
